import {DadosParaSolicitacao} from "@/models/sie-pedidos/dadosParaSolicitacao";

const dadosFormSolicitacao = {
  isLoading: false,
  currentStep: 1,
  dadosParaSolicitacao: DadosParaSolicitacao
}

export default dadosFormSolicitacao;
